/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Ad_Streams_HeadingInputs */

const en_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD streams`)
};

const fr_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux publicitaires`)
};

const de_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Streams`)
};

const it_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flussi pubblicitari`)
};

const ru_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-потоки`)
};

const es_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`transmisiones de anuncios`)
};

const zh_cn2_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD流`)
};

const ja_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADストリーム`)
};

const hi_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एडी स्ट्रीम`)
};

const pt_pt2_audio_embed_export_ad_streams_heading = /** @type {(inputs: Audio_Embed_Export_Ad_Streams_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxos de anúncios`)
};

/**
* | output |
* | --- |
* | "AD streams" |
*
* @param {Audio_Embed_Export_Ad_Streams_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_ad_streams_heading = /** @type {((inputs?: Audio_Embed_Export_Ad_Streams_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Ad_Streams_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_ad_streams_heading(inputs)
	if (locale === "de") return de_audio_embed_export_ad_streams_heading(inputs)
	if (locale === "it") return it_audio_embed_export_ad_streams_heading(inputs)
	if (locale === "ru") return ru_audio_embed_export_ad_streams_heading(inputs)
	if (locale === "es") return es_audio_embed_export_ad_streams_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_ad_streams_heading(inputs)
	if (locale === "ja") return ja_audio_embed_export_ad_streams_heading(inputs)
	if (locale === "hi") return hi_audio_embed_export_ad_streams_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_ad_streams_heading(inputs)
	return en_audio_embed_export_ad_streams_heading(inputs)
});